<template>
  <div class="loader flex items-center" :class="{ full: isFull }">
    <div class="lds-ring">
      <div></div><div></div><div></div><div></div>
    </div>
  </div>
</template>

<script>
export default {

  name: 'Loader',

  data () {
    return {
      isFull: this.full
    }
  },

  props: {
    full: Boolean
  }
}
</script>

<style lang="css" scoped>
.loader {
  pointer-events: none;
  &.full {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    background: var(--color-black);

    .lds-ring {
      display: block;
      margin: 0 auto;
      width: 20vw;
      height: 20vw;

      div {
        width: 20vw;
        height: 20vw;
      }
    }
  }
}
.lds-ring {
  display: inline-block;
  position: relative;
  width: 36px;
  height: 36px;
}
.lds-ring div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 36px;
  height: 36px;
  margin: 6px;
  border: 2px solid var(--color-green);
  border-radius: 50%;
  animation: lds-ring 2.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: var(--color-green) transparent transparent transparent;
}
.lds-ring div:nth-child(1) {
  animation-delay: -0.45s;
}
.lds-ring div:nth-child(2) {
  animation-delay: -0.3s;
}
.lds-ring div:nth-child(3) {
  animation-delay: -0.15s;
}
@keyframes lds-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Loader.vue